import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import './App.css';
import CallView from "./Components/Call/CallView"
import SecurexTrackerView from "./Components/Tracker/SecurexTrackerView"
import TrackerView from "./Components/Tracker/TrackerView"
import Header from "./Components/Header"
import InfoView from "./Components/Info/InfoView"
import MenuView from "./Components/Menu/MenuView"
import { createStore } from 'redux';
import TrackerReducer from'./Redux/TrackerReducer';
import OverlayReducer from'./Redux/OverlayReducer';
import {Provider} from 'react-redux'
import {combineReducers} from 'redux'
import AddressView from './Components/Address/AddressView';
import AmbiguousAddressView from './Components/Address/AmbiguousAddressView';
import SilentAddressView from './Components/SilentAddress/SilentAddressView';
import AmbiguousSilentAddressView from './Components/SilentAddress/AmbiguousSilentAddressView';
import OverlayHandler from './Components/Overlays/OverlayHandler';
import ReserverenView from './Components/Reserveren/ReserverenView';
import NotFound from './Components/Error/NotFound';
import CadeauView from './Components/Cadeau/CadeauView';
import SetCookieView from './Components/SetCookie/SetCookieView';
import SetTokenView from './Components/SetToken/SetTokenView';
import PrivacyPolicyView from './Components/PrivacyPolicy/PrivacyPolicyView';
import CookiePolicyView from './Components/CookiePolicy/CookiePolicyView';
import Onboarding from './Components/Onboarding/Onboarding';
import ConfigEditor from './Components/Admin/ConfigEditor';
import { ConfigProvider, useConfig } from './context/ConfigContext';
import { LanguageProvider } from './context/LanguageContext';

export let store = createStore(combineReducers({tracker: TrackerReducer, overlay: OverlayReducer}), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

function AppContent() {
  const [showOnboarding, setShowOnboarding] = useState(false);
  const { meta, getTranslation, loading } = useConfig();

  // Get onboarding config from current language translation
  const currentLang = localStorage.getItem('language') || meta?.defaultLanguage || 'nl';
  const translation = getTranslation(currentLang);
  const onboardingEnabled = translation?.onboarding?.enabled !== false;

  useEffect(() => {
    // Check if onboarding should be shown
    const onboardingCompleted = localStorage.getItem('onboardingCompleted');
    if (onboardingCompleted !== 'true' && onboardingEnabled && !loading) {
      setShowOnboarding(true);
    }
  }, [onboardingEnabled, loading]);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
  };

  return (
    <div>
      {showOnboarding && <Onboarding onComplete={handleOnboardingComplete} />}
      <Router>
        <Header></Header>
        <Routes>
          <Route path="/securex" element={<SecurexTrackerView />} />
          <Route path="/securextest" element={<SecurexTrackerView />} />

          <Route path="/" element={<TrackerView />} />
          <Route path="/address" element={<AddressView />} />
          <Route path="/address/ambiguous" element={<AmbiguousAddressView />} />
          <Route path="/silentaddress" element={<SilentAddressView />} />
          <Route path="/silentaddress/ambiguous" element={<AmbiguousSilentAddressView />} />
          <Route path="/call" element={<CallView />} />
          <Route path="/info" element={<InfoView />} />
          <Route path="/about" element={<InfoView />} />
          <Route path="/aboutapp" element={<InfoView />} />
          <Route path="/status" element={<InfoView />} />
          <Route path="/menu" element={<MenuView />} />
          <Route path="/reserveren" element={<ReserverenView />} />
          <Route path="/cadeau/:barcode?" element={<CadeauView />} />
          <Route path="/setcookie/:apikey?/:division_id?" element={<SetCookieView />} />
          <Route path="/settoken" element={<SetTokenView />} />
          <Route path="/privacypolicy" element={<PrivacyPolicyView />} />
          <Route path="/cookiepolicy" element={<CookiePolicyView />} />
          <Route path="/admin/config" element={<ConfigEditor />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <OverlayHandler></OverlayHandler>
      </Router>
    </div>
  );
}

function AppWithLanguage() {
  const { meta } = useConfig();

  return (
    <LanguageProvider
      supportedLanguages={meta?.supportedLanguages}
      defaultLanguage={meta?.defaultLanguage}
    >
      <AppContent />
    </LanguageProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider>
        <AppWithLanguage />
      </ConfigProvider>
    </Provider>
  );
}

export default App;
